module.exports = __webpack_public_path__ + "static/media/sankhnad.531e44e0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/images/sankhnad.mp3
// module id = 538
// module chunks = 0